module.exports = __webpack_public_path__ + "img/card.d953f38e.png";